import * as React from 'react';
import { useTranslation } from 'next-i18next';

import { Heading, Button } from '@restworld/ui-ds-base';

import { useApplicationModalToggle, useRedirectRoute } from '../form-inputs.hooks';
import { CoffeeCupIcon } from '../svg';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IWizardPauseSaveConfirmProps {
  onRecordEvent?: () => void;
}
export const WizardPauseSaveConfirmModal: React.FunctionComponent<IWizardPauseSaveConfirmProps> = ({
  onRecordEvent,
}) => {
  const { closeModal } = useApplicationModalToggle();
  const { redirectUserCallback } = useRedirectRoute();
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-4">
        <div className="self-center">
          <CoffeeCupIcon />
        </div>
        <Heading size={3} align="center" weight="bold">
          {t('onboarding-page:pause_and_continue_later')}
        </Heading>
        <Heading size={5} align="center" color="muted" weight="normal">
          {t('onboarding-page:continue_filling_in_the_information_in_your_profile')}
        </Heading>
      </div>
      <div className="flex flex-col gap-4 w-full justify-center items-center">
        <Button
          fullwidth
          onClick={() => {
            onRecordEvent && onRecordEvent();
            redirectUserCallback();
          }}
        >
          {t('common:continue_later')}
        </Button>
        <Button fullwidth variant="secondary-neutral" onClick={closeModal}>
          {t('common:cancel')}
        </Button>
      </div>
    </div>
  );
};
export default WizardPauseSaveConfirmModal;
